export default "__VITE_ASSET__DFJdw6tK__"